import { Box, styled } from '@mui/material'

export const StyledLogosBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}))
